import React from 'react';
import { Dialog as MuiDialog, DialogContent, DialogTitle } from '@mui/material';
import Typography from '../../atoms/Text';
import { DialogProps as MuiDialogProps } from '@mui/material/Dialog';
import './dialog.scss';
import MuiFaIcon from '../../atoms/MuiFaIcon';

export function Dialog({
  children,
  onClose,
  title,
  subtitle,
  closeLabel = 'Close',
  showCloseButton = true,
  ...MuiDialogProps
}: {
  children: React.ReactNode;
  onClose?: () => void;
  title?: string;
  subtitle?: string;
  closeLabel?: string;
  showCloseButton?: boolean;
} & MuiDialogProps) {
  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <MuiDialog onClose={handleClose} fullWidth {...MuiDialogProps}>
      {showCloseButton && (
        <button
          onClick={handleClose}
          className="dialog-close-button"
          aria-label={closeLabel}
          title={closeLabel}
        >
          <MuiFaIcon name="fas fa-times" />
        </button>
      )}
      {title && (
        <DialogTitle sx={subtitle ? { pb: 0 } : undefined}>{title}</DialogTitle>
      )}
      {subtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ px: 3, pt: 0.5, pb: 1 }}
        >
          {subtitle}
        </Typography>
      )}
      <DialogContent>{children}</DialogContent>
    </MuiDialog>
  );
}
